/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PriorityRequestFormFilter = {
    All: 'All',
    Prepared: 'Prepared',
    NotPrepared: 'NotPrepared'
} as const;
export type PriorityRequestFormFilter = typeof PriorityRequestFormFilter[keyof typeof PriorityRequestFormFilter];


export function instanceOfPriorityRequestFormFilter(value: any): boolean {
    for (const key in PriorityRequestFormFilter) {
        if (Object.prototype.hasOwnProperty.call(PriorityRequestFormFilter, key)) {
            if (PriorityRequestFormFilter[key as keyof typeof PriorityRequestFormFilter] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PriorityRequestFormFilterFromJSON(json: any): PriorityRequestFormFilter {
    return PriorityRequestFormFilterFromJSONTyped(json, false);
}

export function PriorityRequestFormFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriorityRequestFormFilter {
    return json as PriorityRequestFormFilter;
}

export function PriorityRequestFormFilterToJSON(value?: PriorityRequestFormFilter | null): any {
    return value as any;
}

export function PriorityRequestFormFilterToJSONTyped(value: any, ignoreDiscriminator: boolean): PriorityRequestFormFilter {
    return value as PriorityRequestFormFilter;
}

